import { useCallback, useEffect, useState } from 'react'
import {
  DEFAULT_RESET_EMAIL_COOLDOWN_SECONDS,
  getResetEmailCooldownRemainingSeconds,
  startResetEmailCooldown,
} from '@/lib/auth-rate-limit'

interface UseResetEmailCooldownOptions {
  tickIntervalMs?: number
}

export function useResetEmailCooldown(options?: UseResetEmailCooldownOptions) {
  const tickIntervalMs = options?.tickIntervalMs ?? 1000
  const [remainingSeconds, setRemainingSeconds] = useState(() => getResetEmailCooldownRemainingSeconds())

  const refresh = useCallback(() => {
    setRemainingSeconds(getResetEmailCooldownRemainingSeconds())
  }, [])

  useEffect(() => {
    const timer = window.setInterval(() => {
      setRemainingSeconds(getResetEmailCooldownRemainingSeconds())
    }, tickIntervalMs)

    return () => {
      window.clearInterval(timer)
    }
  }, [tickIntervalMs])

  const startCooldown = useCallback((seconds = DEFAULT_RESET_EMAIL_COOLDOWN_SECONDS) => {
    startResetEmailCooldown(seconds)
    setRemainingSeconds(seconds)
  }, [])

  return {
    remainingSeconds,
    isCoolingDown: remainingSeconds > 0,
    startCooldown,
    refresh,
  }
}
